import styles from "./error404.module.css";
import Helmet from "react-helmet";
import Header from "../../components/HeaderPublicOther";
import Footer from "../../components/FooterPublicOther";

function Page404() {
  return (<div>
    <Helmet title="404 Error" />
    <Header />
    <div className="WhiteBG">
      <div className={`${styles.ErrorMain}`}>
        <div className={`${styles.ErrorMainSec}`}>
          <img src="/static/img/404.jpg" alt="" className={`${styles.SuccessImg}`} />
          <p className={`${styles.ErrorTitle}`}>Page not found</p>
          <p className={`${styles.PaymentSuccessTitleSub}`}>The page you are looking for might have been removed.</p>
          <a href="/" className={`${styles.LearnMBUBanner}`}>Return to website</a>
        </div>
      </div>
      <Footer />
    </div>
  </div>);
}

export default Page404;